import React from 'react';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import HowToRegRoundedIcon from '@mui/icons-material/HowToRegRounded';
import TabbedPage from '../components/TabbedPage';
import MarkSalaryCreditedPage from '../components/LeaveAttendanceComps/PayrollComps/MarkSalaryCreditedPage';
import SalaryRegister from '../components/LeaveAttendanceComps/PayrollComps/SalaryRegister';

const TABS = [
    { key: 'register', label: 'Register', icon: ReceiptLongRoundedIcon, module: 'payroll-register', render: () => <SalaryRegister /> },
    { key: 'approve', label: 'Approve & Credit', icon: HowToRegRoundedIcon, module: 'run-payroll', render: () => <MarkSalaryCreditedPage /> },
];

export default function RunPayrollPage() {
    return <TabbedPage tabs={TABS} />;
}
